<template>
	<select class="form-control" v-on:change="updateModel" v-model="selected" required="required">
		<option v-for="role in roles" v-bind:value="role.id">{{role.name}}</option>
	</select>
</template>

<script>
	import Request from '../request'
	export default{
		name: 'roles',
		props: {
			model: {
				required: true
			}
		},
		data(){
			return{
				selected: '',
				roles: [
				    {
				        "id": '',
				        "name": "No roles yet."
				    }
				]
			}
		},
		mounted(){
			// this.selected = this.model;
			console.log(this.model)
			this.getRoles()
		},
		methods: {
			
			updateModel: function(){
				this.$emit('update:model', this.selected)
				//console.log(this.selected)
			},

			getRoles: function(){

				var roles = {
					what: 'roles',
					params: {
						company_id: this.$store.getters.user_data.data.company_id
					}
				}

				//console.log(roles)
				Request.makeGetRequest(roles)
					.then((response)=>{
						if(response.type == 'roles'){
							this.roles = response.data
							if(isNaN(this.model)) {
								this.selected = this.roles.find( role => role.name == this.model).id;
								console.log(this.selected)
							}
	                    }
	                })
					.catch((error)=>{
						console.log(error)
					})
			}
		}
	}
</script>